import { memo, Suspense, useCallback } from "react";
import { Route, Routes } from "react-router-dom";
import { PublicRoute } from "./PublicRoute";
import { AppRoutesProps, routeConfig } from "../config/routeConfig";
import { ProtectedRoute } from "@/zapi-admin/app/providers/router/ui/ProtectedRoute";
import { NonProtectedRoute } from "@/zapi-admin/app/providers/router/ui/NonProtectedRoute";

const AppRouter = () => {
  const renderWithWrapper = useCallback((route: AppRoutesProps) => {
    const element = <Suspense fallback={<div>Loading...</div>}>{route.element}</Suspense>;
    switch (route.routePrivilege) {
      case "protected":
        return <Route key={route.path} path={route.path} element={<ProtectedRoute>{element}</ProtectedRoute>} />;
      case "nonprotected":
        return <Route key={route.path} path={route.path} element={<NonProtectedRoute>{element}</NonProtectedRoute>} />;
      case "public":
      default:
        return <Route key={route.path} path={route.path} element={<PublicRoute>{element}</PublicRoute>} />;
    }
  }, []);

  return <Routes>{Object.values(routeConfig).map(renderWithWrapper)}</Routes>;
};

export default memo(AppRouter);
